import { render } from "./AuthorizationCodeScan.vue?vue&type=template&id=572618e2"
import script from "./AuthorizationCodeScan.vue?vue&type=script&lang=js"
export * from "./AuthorizationCodeScan.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/hostess.westfield.expansja.pl/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__